// extracted by mini-css-extract-plugin
export default {"readyToImportFolder":"RQhBVon8M88bBWGoGPlG"};